<template>
  <div>
    <!-- 合同信息变更 -->
    <div class="section-card">
      <div class="section-header-bar">
        <span class="section-title"><i class="el-icon-document"></i> 合同信息变更</span>
        <el-button type="text" size="mini" @click="showContractInfo = !showContractInfo">
          {{ showContractInfo ? '收起' : '展开' }}
        </el-button>
      </div>
      <el-table v-show="showContractInfo" :data="changeData" border style="width: 100%" header-row-class-name="headerTable"
        :cell-style="{ padding: '8px 0' }">
        <el-table-column class-name="cellTable" prop="name" label="数据项" align="center" width="180">
          <template slot-scope="scope">
            <span class="data-item-label">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="oldValue" :label="oldValueLabel" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.path === 'contractFilePath'">
              <div v-if="scope.row.oldValue">
                <el-button size="mini" type="primary" icon="el-icon-download" plain
                  @click="download(oldData.id, 'contract', 'oldData')">下载</el-button>
                <el-button size="mini" type="primary" icon="el-icon-view" plain
                  @click="preview(oldData.id, 'contract', 'oldData')">预览</el-button>
              </div>
              <el-tag v-else type="info" size="small">系统中不存在合同文件数据</el-tag>
            </div>
            <div v-else-if="scope.row.path === 'priceFilePath'">
              <div v-if="scope.row.oldValue">
                <el-button size="mini" type="primary" icon="el-icon-download" plain
                  @click="download(oldData.id, 'price', 'oldData')">下载</el-button>
                <el-button size="mini" type="primary" icon="el-icon-view" plain
                  @click="preview(oldData.id, 'price', 'oldData')">预览</el-button>
              </div>
              <el-tag v-else type="info" size="small">系统中不存在价格申请截图文件</el-tag>
            </div>
            <div v-else-if="scope.row.path === 'projectAnnex'">
              <div v-if="scope.row.oldValue">
                <el-button size="mini" type="primary" icon="el-icon-download" plain
                  @click="downloadProjectAnnexFile(oldData.id, scope.row.oldValue.projectMainTypeId)">下载</el-button>
                <el-button size="mini" type="primary" icon="el-icon-view" plain
                  @click="previewProjectAnnexFile(oldData.id, scope.row.oldValue.projectMainTypeId)">预览</el-button>
              </div>
              <el-tag v-else type="info" size="small">系统中不存在项目文件数据</el-tag>
            </div>
            <span v-else :class="{'value-changed': String(scope.row.oldValue) !== String(scope.row.newValue)}">
              {{ scope.row.oldValue || '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="newValue" :label="newValueLabel" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.path === 'contractFilePath'">
              <div v-if="scope.row.newValue">
                <el-button size="mini" type="primary" icon="el-icon-download" plain
                  @click="download(newData.id, 'contract', 'newData')">下载</el-button>
                <el-button size="mini" type="primary" icon="el-icon-view" plain
                  @click="preview(newData.id, 'contract', 'newData')">预览</el-button>
              </div>
              <el-tag v-else type="info" size="small">未重新上传合同文件</el-tag>
            </div>
            <div v-else-if="scope.row.path === 'priceFilePath'">
              <div v-if="scope.row.newValue">
                <el-button size="mini" type="primary" icon="el-icon-download" plain
                  @click="download(newData.id, 'price', 'newData')">下载</el-button>
                <el-button size="mini" type="primary" icon="el-icon-view" plain
                  @click="preview(newData.id, 'price', 'newData')">预览</el-button>
              </div>
              <el-tag v-else type="info" size="small">系统中不存在价格申请截图</el-tag>
            </div>
            <div v-else-if="scope.row.path === 'projectAnnex'">
              <div v-if="scope.row.newValue">
                <el-button size="mini" type="primary" icon="el-icon-download" plain
                  @click="downloadProjectAttachmentFile(newData.id, scope.row.newValue.projectMainTypeId)">下载</el-button>
                <el-button size="mini" type="primary" icon="el-icon-view" plain
                  @click="previewProjectAttachmentFile(newData.id, scope.row.newValue.projectMainTypeId)">预览</el-button>
              </div>
              <el-tag v-else type="info" size="small">不存在项目文件</el-tag>
            </div>
            <span v-else-if="String(scope.row.oldValue) === String(scope.row.newValue)">{{ scope.row.newValue || '-' }}</span>
            <span v-else class="value-changed">{{ scope.row.newValue || '-' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 补充分析要求 -->
    <div class="section-card" v-if="(isAnalysisProject(newData) || isAnalysisProject(oldData)) && (hasMoreAnalysisRequest(newData) || hasMoreAnalysisRequest(oldData))">
      <div class="section-header-bar">
        <span class="section-title"><i class="el-icon-data-analysis"></i> 补充分析要求</span>
      </div>
      <analysis-change-data :old-data="oldData" :new-data="newData"></analysis-change-data>
    </div>

    <!-- 项目信息 -->
    <div class="section-card" v-if="[...oldData.specificProjectType, ...newData.specificProjectType].length > 0">
      <div class="section-header-bar">
        <span class="section-title"><i class="el-icon-s-order"></i> {{ projectTitle }}</span>
      </div>
      <project-change-data :old-data="oldData.specificProjectType" :new-data="newData.specificProjectType"
        :id="oldData.id" :type="projectChangeType"></project-change-data>
    </div>

    <!-- 保护剂信息 -->
    <div class="section-card" v-if="hasPendingProtectiveFluidMail(newData) || newData.materials?.length > 0">
      <div class="section-header-bar">
        <span class="section-title"><i class="el-icon-box"></i> 保护剂信息</span>
      </div>
      <materials-change-data :old-data="hasPendingProtectiveFluidMail(newData) ? oldData.materials : []" :new-data="newData.materials"></materials-change-data>
    </div>

    <!-- 解离样品投递方式 -->
    <div class="section-card" v-if="hasProtectiveFluidInfo(oldData) || hasProtectiveFluidInfo(newData)">
      <div class="section-header-bar">
        <span class="section-title"><i class="el-icon-truck"></i> 解离样品投递方式</span>
      </div>
      <protective-fluid-change-data :old-data="oldData" :new-data="newData"></protective-fluid-change-data>
    </div>

    <!-- 硬盘选购信息变更 -->
    <div class="section-card" v-if="(oldData.hardDiskPurchaseInfo?.length > 0) || (newData.hardDiskPurchaseInfo?.length > 0)">
      <div class="section-header-bar">
        <span class="section-title"><i class="el-icon-s-order"></i> 硬盘选购信息变更</span>
      </div>
      <purchase-change-data :old-data="oldData.hardDiskPurchaseInfo" :new-data="newData.hardDiskPurchaseInfo"></purchase-change-data>
    </div>

    <!-- 文件预览 -->
    <file-preview v-if="showFile" :show-dialog="showFile" :response="fileInfo" @submit="close"></file-preview>
  </div>
</template>

<script>
import FilePreview from "@/components/file/FilePreview.vue";
import ProjectChangeData from "@/components/sales/ProjectChangeData.vue";
import MaterialsChangeData from "@/components/sales/MaterialsChangeData.vue";
import ProtectiveFluidChangeData from "@/components/sales/ProtectiveFluidChangeData.vue";
import AnalysisChangeData from "@/components/sales/AnalysisChangeData.vue";
import PurchaseChangeData from "@/components/sales/PurchaseChangeData.vue";
import changeContractMethodsMixin from "@/mixins/changeContractMethodsMixin";

export default {
  name: "ContractChangeSections",
  mixins: [changeContractMethodsMixin],
  components: { AnalysisChangeData, MaterialsChangeData, ProtectiveFluidChangeData, ProjectChangeData, FilePreview, PurchaseChangeData },
  props: {
    changeData: { type: Array, required: true },
    oldData: { type: Object, default: () => ({}) },
    newData: { type: Object, default: () => ({}) },
    oldValueLabel: { type: String, default: '变更前' },
    newValueLabel: { type: String, default: '变更后' },
    projectTitle: { type: String, default: '项目信息' },
    projectChangeType: { type: String, default: '' },
  },
  data() {
    return {
      showContractInfo: true,
      showFile: false,
      fileInfo: '',
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/contractChangeSections.scss";
</style>
